import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { fetchApiDataDup } from "../../../redux/reducers/commonApiSlice";
import FiltersTrainerDetails from "../trainer-details/common/FiltersTrainerDetails";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import {
  convertStraight,
  convertThenFormat,
  currentMonthName,
  currentMonthNumber,
  currentYear,
  formatDateTimezon,
} from "../../common-data/Converts";
import { BodyBuilder } from "../../../exports/Images";
import { stringToColor } from "../../../data/Constants";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import PayoutsTable from "../../components-bootstrap/PayoutsTable";
import { ptMembers } from "../../../data/ApiEndpoints";
import UserDetails from "../../incentive-system/user-details/UserDetails";
import OccupencyDetails from "../../components-react/OccupencyDetails";

const GTPTTrainerDetails = ({
  prevModValues,
  userInfoData,
  prevAllFilters,
  isPTTrainerPerformance,
}) => {
  const dispatch = useDispatch();
  const { loadingDup, dataDup } = useSelector((state) => state.common);

  const { modName1, rowData1 } = prevModValues;

  const typeClicked =
    modName1 === "trainer_active_PT_member"
      ? "active"
      : modName1 === "trainer_expiring_PT" ||
        modName1 === "trainer_expiring_PT_this_month"
      ? "expiring"
      : modName1 === "trainer_expired_PT"
      ? "expired"
      : modName1 === "PT_business_lost"
      ? "pt_business_lost"
      : modName1;

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilters = {
    selectedMonth:
      typeClicked === "pt_business_lost" || typeClicked === "all"
        ? ""
        : modName1 === "trainer_PT_this_month"
        ? {
            label: currentMonthName,
            value: currentMonthNumber,
          }
        : !isPTTrainerPerformance && prevAllFilters?.selectedMonth
        ? prevAllFilters.selectedMonth
        : "",
    selectedYear:
      typeClicked === "pt_business_lost" || typeClicked === "all"
        ? ""
        : {
            label: currentYear,
            value: currentYear,
          },
    selPTPlanStatus: "",
    selRegularPlanStatus: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    performance_evaluation: isPTTrainerPerformance ? true : false,
    type: modName1 === "trainer_PT_this_month" ? "" : typeClicked,
    gym_id: rowData1?.gym_id || "",
    trainer_id: rowData1?.trainer_id || "",
    month:
      typeClicked === "pt_business_lost" || typeClicked === "all"
        ? ""
        : allFilters.selectedMonth?.value || "",
    year:
      typeClicked === "pt_business_lost" || typeClicked === "all"
        ? ""
        : allFilters.selectedYear?.value || "",
    subscription_status: allFilters.selPTPlanStatus?.value || "",
    regular_subscription_status: allFilters.selRegularPlanStatus?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
    image: "",
    partialDetails: [],
  };
  const [modValues, setModValues] = useState(iniModValues);
  const iniPTDatas = {
    pagination: [],
    allDetailData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);

  const onClickReset = () => {
    setAllFilters(iniAllFilters);
    setFilters(iniFilters);
    setSearchFilterApplied(false);
  };

  const onCloseModal = (name) => {
    if (name === "mod1") {
      setModValues((prevs) => ({
        ...prevs,
        isModOpen1: false,
        modName1: "",
        rowData1: "",
      }));
    } else setModValues(iniModValues);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getDetails(filters, endpoint) {
    dispatch(
      fetchApiDataDup({
        method: "GET",
        endpoint: endpoint,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  const onClickValues = (e, row, name) => {
    e.preventDefault();

    const shiftDetailsQP = `gym_id=${row?.gym_id || ""}&trainer_id=${
      row?.trainer_id || ""
    }`;

    const cardName = name;

    setModValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      modName: cardName,
      rowData: row || "",
      shiftDetailsQP: shiftDetailsQP || "",
    }));
  };

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedMonth:
        typeClicked === "pt_business_lost" || typeClicked === "all"
          ? ""
          : modName1 === "trainer_PT_this_month" ||
            modName1 === "trainer_expiring_PT_this_month"
          ? {
              label: currentMonthName,
              value: currentMonthNumber,
            }
          : !isPTTrainerPerformance && prevAllFilters?.selectedMonth
          ? prevAllFilters.selectedMonth
          : "",
    }));
  }, [modName1, prevAllFilters?.selectedMonth]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      performance_evaluation: isPTTrainerPerformance ? true : false,
    }));
  }, [isPTTrainerPerformance]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      type: modName1 === "trainer_PT_this_month" ? "" : typeClicked,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: rowData1?.gym_id || "",
      trainer_id: rowData1?.trainer_id || "",
      month:
        typeClicked === "pt_business_lost" || typeClicked === "all"
          ? ""
          : allFilters.selectedMonth?.value || "",
      year:
        typeClicked === "pt_business_lost" || typeClicked === "all"
          ? ""
          : allFilters.selectedYear?.value || "",
      subscription_status: allFilters.selPTPlanStatus?.value || "",
      regular_subscription_status: allFilters.selRegularPlanStatus?.value || "",
    }));
  }, [
    rowData1?.gym_id,
    rowData1?.trainer_id,
    allFilters.selectedMonth,
    allFilters.selectedYear,
    typeClicked,
    isPage,
    pageLimit,
    modName1,
    allFilters.selPTPlanStatus,
    allFilters.selRegularPlanStatus,
  ]);

  useEffect(() => {
    getDetails(filters, ptMembers);
  }, [filters]);

  useEffect(() => {
    if (dataDup?.status && dataDup?.data?.length > 0) {
      setAllDatas((prevs) => ({
        ...prevs,
        allDetailData: dataDup.data,
        pagination: dataDup?.pagination?.length > 0 ? dataDup.pagination : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [dataDup]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  const tbColumn = [
    {
      dataField: "member_name",
      text: "Member",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer">
          {row?.member_profile ? (
            <img
              src={row?.member_profile || BodyBuilder}
              alt={row?.member_name || "N/A"}
              className="image"
              onClick={() =>
                row?.member_profile &&
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "image_view",
                  image: row?.member_profile,
                }))
              }
            />
          ) : (
            <div
              className="nameInitials"
              style={{ backgroundColor: stringToColor(row?.member_name || "") }}
            >
              <span className="nameLetters">
                <span className="nameLetters">
                  {row?.member_name
                    ?.split(" ")
                    .map((namePart, index) =>
                      index === 0 ||
                      index === row?.member_name?.split(" ").length - 1
                        ? namePart.charAt(0).toUpperCase()
                        : null
                    )}
                </span>
              </span>
            </div>
          )}
          <span
            className="tb-data text-start link"
            onClick={(e) => onClickValues(e, row, "member_info")}
          >
            {row?.member_name || "NA"}
            <br />
            {(row?.member_mobile || row?.member_email) && (
              <small className="lowercase">
                {row?.member_mobile || ""}
                <br />
                {row?.member_email || ""}
              </small>
            )}
          </span>
        </div>
      ),
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => (
        <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
      ),
    },
    {
      dataField: "trainer_name",
      text: "Trainer / Exp Level",
      formatter: (cell, row) => (
        <div
          className="emeberDetailsRowContainer column minWidth150"
          onClick={(e) => onClickValues(e, row, "shift_details")}
        >
          <p className="info bold link">
            {row?.trainer_name || "N/A"}
            <br />
            <span className="small-info" style={{ fontWeight: "500" }}>
              ( {row?.experience_level || "N/A"})
            </span>
          </p>
        </div>
      ),
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (cell, row) => (
        <span
          className={`tb-data ${row?.is_partial === "true" ? "link" : ""}`}
          onClick={() =>
            row?.is_partial === "true"
              ? setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "partial_details",
                  partialDetails: row?.payment_details || [],
                }))
              : null
          }
        >
          {row?.is_partial === "true" ? "Partial" : "Full"}
        </span>
      ),
    },
    {
      dataField: "price",
      text: "Total Amount",
      formatter: (cell, row) => (
        <span className="tb-data bold">
          ₹{convertThenFormat(row?.price || 0)}
        </span>
      ),
    },
    {
      dataField: "total_partial_price",
      text: "Partial Amount",
      formatter: (cell, row) => (
        <span className="tb-data bold">
          {row?.is_partial === "true"
            ? `₹${convertThenFormat(row?.total_partial_price || 0)}`
            : "-"}
        </span>
      ),
    },
    {
      dataField: "total_online",
      text: "Online Amount",
      formatter: (cell, row) => (
        <span className="tb-data bold">
          ₹
          {convertThenFormat(
            row?.is_partial === "true"
              ? row?.partial_total_online
              : row?.total_online || 0
          )}
        </span>
      ),
    },
    {
      dataField: "total_cash",
      text: "Cash Amount",
      formatter: (cell, row) => (
        <span className="tb-data bold">
          ₹
          {convertThenFormat(
            row?.is_partial === "true"
              ? row?.partial_total_cash
              : row?.total_cash || 0
          )}
        </span>
      ),
    },
    {
      dataField: "session_status",
      text: "session status(No of Days)",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background: "#FFEDC0",
              color: "#171717",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.session_status || "NA"}
          </p>
          <p className="info">{row?.duration || 0} Days</p>
        </div>
      ),
    },
    {
      dataField: "date_added",
      text: "PT Purchase date",
      formatter: (cell, row) => (
        <span className="tb-data minWidth100">
          {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
        </span>
      ),
    },
    {
      dataField: "start_date",
      text: "PT Plan Duration",
      formatter: (cell, row) => (
        <span className="tb-data minWidth100 underline">
          {row?.start_date ? formatDateTimezon(row.start_date) : "-"}
          <br />
          {row?.expire_date ? formatDateTimezon(row.expire_date) : "-"}
        </span>
      ),
    },
    {
      dataField: "subscription_status",
      text: "PT Subscription status",
      formatter: (cell, row) => (
        <span
          className="tb-data minWidth100"
          style={{
            background:
              row?.subscription_status === "active" ? "#0A701B" : "#F13434",
            color: "#fff",
            borderRadius: "8px",
            padding: "5px 10px",
          }}
        >
          {row?.subscription_status || "NA"}
        </span>
      ),
    },
    {
      dataField: "regular_subscription_status",
      text: "Regular Subscription status",
      formatter: (cell, row) => (
        <span
          className="tb-data minWidth100"
          style={{
            background:
              row?.regular_subscription_status === "active"
                ? "#0A701B"
                : "#F13434",
            color: "#fff",
            borderRadius: "8px",
            padding: "5px 10px",
          }}
        >
          {row?.regular_subscription_status || "NA"}
        </span>
      ),
    },
  ];

  const pmInfoColumns = [
    {
      dataField: "payment_created",
      text: "Payment Created",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.payment_created
              ? formatDateTimezon(row.payment_created)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "Schedule Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.date ? convertStraight(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.amount || 0) || 0}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background:
                row?.status === "pending"
                  ? "#FFEDC0"
                  : row?.status === "completed"
                  ? "#B4E7B9"
                  : "#F3DADA",
              color:
                row?.status === "pending"
                  ? "#171717"
                  : row?.status === "completed"
                  ? "#0A701B"
                  : "#D90000",
              borderRadius: "10px",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "image_view" ||
            modValues.modName === "partial_details"
              ? "mod-width-50p"
              : ""
          }`}
        >
          {
            <ModalHeadAndClose
              title={modValues.modName?.replace(/_/g, " ")}
              onClose={onCloseModal}
            />
          }

          {modValues.modName === "image_view" ? (
            <div className="discussionModalMessage">
              <img
                src={modValues.image}
                alt="profile"
                style={{
                  width: "400px",
                  height: "400px",
                }}
              />
            </div>
          ) : modValues.modName === "partial_details" ? (
            <div className="fullWidthFlexCenter separatedTable">
              <PayoutsTable
                dataValues={modValues.partialDetails}
                columnsValues={pmInfoColumns}
              />
            </div>
          ) : modValues.modName === "member_info" ? (
            <UserDetails row={modValues?.rowData} userInfoData={userInfoData} />
          ) : modValues.modName === "shift_details" ? (
            <OccupencyDetails
              queryParametersForAll={modValues.shiftDetailsQP}
            />
          ) : null}
        </div>
      </Modal>

      <FiltersTrainerDetails
        decryptedText={userInfoData}
        name={"pt-details-info"}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickReset={onClickReset}
        onClickSearch={onClickSearch}
        searchFilterApplied={searchFilterApplied}
        clickedCard={typeClicked}
      />

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
        {loadingDup ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allDetailData}
            tableColumns={tbColumn}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            isFirstColSticky={true}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>
    </>
  );
};

export default GTPTTrainerDetails;
